import React from 'react';
import { GiftIcon, ReceiptTextIcon, ScaleIcon, SettingsIcon, WalletIcon } from 'lucide-react';
import { OperatorShell } from './OperatorShell';
import type { NavGroup } from './OperatorShell';
import { koboToNaira } from '../../utils/campagift';
import { useCampaGift } from '../../contexts/CampaGiftContext';
const GROUPS: NavGroup[] = [{
  label: 'CampaGift',
  items: [{
    to: '/merchant',
    label: 'Redemption desk',
    icon: GiftIcon,
    end: true
  }, {
    to: '/merchant/redemptions',
    label: 'Redemptions',
    icon: ReceiptTextIcon
  }]
}, {
  label: 'Money',
  items: [{
    to: '/merchant/receivables',
    label: 'Receivables and settlement',
    icon: WalletIcon
  }, {
    to: '/merchant/disputes',
    label: 'Disputes',
    icon: ScaleIcon
  }]
}, {
  label: 'Setup',
  items: [{
    to: '/merchant/configuration',
    label: 'Configuration',
    icon: SettingsIcon
  }]
}];
export function MerchantShell() {
  const {
    redemptions,
    merchantId
  } = useCampaGift();
  const outstanding = redemptions.filter(r => r.merchantId === merchantId && r.state === 'confirmed' && !r.settlementId).reduce((total, r) => total + r.netReceivableKobo, 0);
  return <OperatorShell consoleKey="merchant" consoleName="Merchant console" scopeLine="Scoped to your own redemptions and settlements. You cannot see customer accounts or other merchants." groups={GROUPS} summary={<div data-id="element-5214" data-mp="qac844x5qtp1">
          <p className="text-caption text-ink-muted" data-id="element-5215" data-mp="qa2gkcwgseh8">Awaiting settlement</p>
          <p className="cz-num mt-1 text-h4 font-semibold text-ink" data-id="element-5216" data-mp="m90g5sqt9wdo">{koboToNaira(outstanding)}</p>
        </div>} data-id="element-5213" data-mp="hayx37tdxx27" />;
}